module.exports = __webpack_public_path__ + "img/logo_merahputih.com.b9de78e7.png";